import React from 'react';
import { BlockDecoration } from '../../customization/BlockDecoration';
import { Col } from '../../grid';
import { block } from '../../utils';
import Anchor from '../Anchor/Anchor';
import './BlockBase.css';
const b = block('block-base');
const BlockBase = (props) => {
    const { anchor, visible, children, className, resetPaddings, qa } = props;
    return (React.createElement(Col, { className: b({ ['reset-paddings']: resetPaddings }, className), visible: visible, reset: true, dataQa: qa },
        React.createElement(BlockDecoration, null,
            anchor && React.createElement(Anchor, { id: anchor.url, className: b('anchor') }),
            children)));
};
export default BlockBase;
